import { Component, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { Cloudinary, WindowReference, XmStore, XmStoreUtil } from 'core/services';
import { CmsMyAccount } from 'store/cms/models';

@Component({
    selector: 'xm-my-account-error',
    styleUrls: ['./error.scss'],
    templateUrl: './error.html',
    standalone: false
})
export class XmMyAccountErrorComponent implements OnInit {
    @Input() public apiRequestData: StoreFetchInfo;

    public pageData: CmsErrorDetails;
    public window: WindowReference;
    public imageOptions: MediaImageOptions;
    public refreshPromise: Promise<void>;

    private xmStore: XmStore;
    private subscriptions: Subscription[] = [];

    constructor(xmStore: XmStore) {
        Object.assign(this, { xmStore });
    }

    public ngOnInit(): void {
        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsMyAccount>(CmsMyAccount), (cmsMyAccount: CmsMyAccount) => {
            this.pageData = cmsMyAccount.error;
            this.imageOptions = {
                mobile: Cloudinary.generateMediaFromCms(this.pageData.image)
            };
        }));
    }

    public refreshPage(): void {
        this.refreshPromise = this.xmStore.fetchPromise(this.apiRequestData.apiAction, {
            params: this.apiRequestData.apiParams
        });
    }
}
